var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "currentColor",
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.633 13.664c.51 2.138 1.16 3.073 3.324 4.053 2.166.978 3.195 2.048 4.044 2.048.848 0 1.813-.936 3.978-1.916 2.165-.98 1.587-1.278 2.097-3.416l-6.075 3.056-7.368-3.825Zm17.83-5.578-9.158-5.304c-.717-.415-1.891-.415-2.609 0L.538 8.086c-.717.416-.717 1.096 0 1.511l9.157 5.305c.717.415 1.892.415 2.61 0l5.92-3.43-6.42-1.555a3.294 3.294 0 0 1-.804.098c-1.157 0-2.094-.576-2.094-1.287 0-.713.938-1.289 2.094-1.289.898 0 1.66.35 1.958.835l6.8 2.309 1.704-.987c.716-.414.716-1.094 0-1.51Zm-2.798 10.052c-.072.438 1.41 1.158 1.552-.122.637-5.771-.458-7.431-.458-7.431l-1.534.889c0-.002 1.3 1.28.44 6.664Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/Class.e354c22f9b36bc38229f3c4aea4701ca.svg";
export { ForwardRef as ReactComponent };